import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./Carousel.style.css"; // Importamos los estilos CSS personalizados

const MyCarousel = () => {
  return (
    <div className="carousel-container">
      <Carousel
        autoPlay={true}
        interval={3000}
        infiniteLoop={true}
        showThumbs={false} // Oculta las miniaturas
        showStatus={false} // Oculta el estado del carrusel
        stopOnHover={true} // Detiene el carrusel cuando se pasa el mouse
      >
        <div className="video-slide">
          <video className="videoStyles" controls>
            <source src="/images/video.mp4" type="video/mp4" />
            Tu navegador no soporta el elemento de video.
          </video>
        </div>
        <div>
          <img src="/images/Img1.jpeg" alt="Image 1" className="imageStyles" />
        </div>
        <div>
          <img src="/images/Img2.jpeg" alt="Image 2" className="imageStyles" />
        </div>
        <div>
          <img src="/images/Img3.jpeg" alt="Image 3" className="imageStyles" />
        </div>
        <div>
          <img src="/images/Img4.jpeg" alt="Image 4" className="imageStyles" />
        </div>
        {/* Agrega más imágenes aquí según sea necesario */}
      </Carousel>
    </div>
  );
};

export default MyCarousel;
